import React, { useState } from 'react';
import { X } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';
import Button from '../common/Button';

const Services = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const openModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };

  const getLocationData = (location) => {
    const data = {
      ratnagiri: {
        title: 'Ratnagiri District',
        description: 'Known for its beautiful beaches, Alphonso mangoes, and cultural heritage, Ratnagiri is a key logistics hub in Maharashtra.',
        areas: ['Chiplun', 'Sangmeshwar', 'Devrukh', 'Rajapur']
      },
      sindhudurg: {
        title: 'Sindhudurg District',
        description: 'Sindhudurg is famous for its fort, pristine beaches, and seamless transportation network connecting coastal Maharashtra.',
        areas: ['Kharepatan', 'Kankavli', 'Tarela', 'Kudal', 'Oras', 'Sawantwadi', 'Banda']
      },
      goa: {
        title: 'Goa',
        description: 'Goa is a bustling tourism and trade destination, making it an important point for our logistics and supply chain operations.',
        areas: ['Pedney', 'Bicholim', 'Mapusa', 'Panjim', 'Phonda', 'Vasco', 'Verna', 'Margao']
      },
      karwar: {
        title: 'Karwar',
        description: 'Karwar, with its strategic coastal location, serves as a key gateway for goods transport between Karnataka and Goa.',
        areas: ['Karwar']
      }
    };
    return data[location];
  };

  const services = [
    {
      num: '01',
      title: 'Road Transportation & Cargo Movement',
      desc: 'Reliable road transportation and cargo movement with a strong focus on safety, efficiency, and on-time delivery.',
    },
    {
      num: '02',
      title: 'Parcel & Freight Delivery',
      desc: 'End-to-end parcel and freight delivery solutions designed for both individual and enterprise shipment requirements.',
    },
    {
      num: '03',
      title: 'Shipment Tracking & Coordination',
      desc: 'Real-time shipment tracking and coordination to ensure full transparency across every stage of delivery.',
    },
    {
      num: '04',
      title: 'Safe Handling & Timely Dispatch',
      desc: 'Secure handling and timely dispatch processes designed to protect cargo integrity throughout transportation.',
    },
    {
      num: '05',
      title: 'End-to-End Logistics Support',
      desc: 'Complete end-to-end logistics support, managing every stage from pickup to final delivery with precision and care.',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <Navbar />

      {/* Page Header */}
      <section className="bg-gradient-to-r from-brand to-brand-hover text-white pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="container mx-auto px-4 lg:px-6 text-center">
          <p className="text-brand-light text-sm font-medium uppercase tracking-widest mb-3">
            What We Do
          </p>
          <h1 className="text-3xl md:text-5xl font-semibold mb-4 leading-tight">
            Precision-driven logistics you can rely on
          </h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Dependable logistics services that ensure timely delivery, secure handling, and complete transparency.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-card shadow-card border border-gray-100 divide-y divide-gray-100 overflow-hidden">
            {services.map((service) => (
              <div key={service.num} className="flex gap-6 md:gap-8 px-6 md:px-10 py-8 hover:bg-gray-50/50 transition-colors">
                <div className="text-brand text-3xl md:text-4xl font-light flex-shrink-0">
                  {service.num}
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-semibold text-dark mb-2">
                    {service.title}
                  </h3>
                  <p className="text-secondary leading-relaxed text-sm md:text-base">
                    {service.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white rounded-card shadow-strong max-w-lg w-full p-6 relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 p-1.5 rounded-btn hover:bg-gray-100 transition"
              aria-label="Close"
            >
              <X className="w-5 h-5 text-secondary" />
            </button>

            {(() => {
              const data = getLocationData(modalContent);
              return (
                <div>
                  <h2 className="text-2xl font-semibold text-brand mb-4">{data.title}</h2>
                  <p className="text-secondary leading-relaxed mb-4">{data.description}</p>
                  <ul className="flex flex-wrap gap-2 mt-4">
                    {data.areas.map((area, idx) => (
                      <li key={idx}>
                        <span className="inline-block rounded-btn border border-brand text-brand px-4 py-2 text-sm font-medium">
                          {area}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-6">
                    <Button variant="primary" onClick={() => setShowModal(false)}>
                      Close
                    </Button>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Services;
